import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap'; //, ModalDismissReasons
import { FormBuilder, Validators} from '@angular/forms'; //FormGroup, FormControl,
import { Router } from '@angular/router'; //, NavigationExtras

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';

import { ForgotPassComponent } from '../forgot-pass/forgot-pass.component';

@Component({
  selector: 'app-signin-up',
  templateUrl: './signin-up.component.html',
  styleUrls: ['./signin-up.component.css']
})


export class SigninUpComponent implements OnInit {

  countries:any;
  isCollapsed = true;
  //isNavbarCollapsed = true;
  closeResult: string;
  airfrightForm;
  calculated_price;
  loginForm;
  signupForm;
  isDisabled = true;

  signup_active = '';
  signup_show = '';
  signin_active = '';
  signin_show = '';

  login_error_msg;
  signup_error_msg;
  
  public isVisible: boolean = false;
  
  constructor(
    private modalService: NgbModal,
    public builder:FormBuilder,
    public bp:BasicProvider, 
    public up:UserProvider,
    public router: Router,
  ) {
    this.countries = this.up.getCountry();
    console.log('qqq',this.bp.model_type)
    if (this.bp.model_type=='signup') {

      
      this.bp.validation_error = '';
      this.login_error_msg = '';
      this.signup_error_msg = '';
      this.bp.close();
      this.signup_active = 'active';
      this.signup_show = 'show active';

      this.signin_active = '';
      this.signin_show = '';

    } else if (this.bp.model_type=='signin') {

      this.bp.validation_error='';
      this.login_error_msg = '';
      this.signup_error_msg = '';
      this.bp.close();
      this.signin_active = 'active';
      this.signin_show = 'show active';

      this.signup_active = '';
      this.signup_show = '';

    }

    this.setsLoginForm();
    this.setSignupForm();
  }


  //Show / hide password
  signin_pass_type = false;
  signup_new_pass_type = false;
  signup_confirm_pass_type = false;
  showPassword(type){
    if( type == 'signin_pass_type' ){
      if(this.signin_pass_type)
        this.signin_pass_type = false;
      else
        this.signin_pass_type = true;
    } else if ( type == 'signup_new_pass_type' ) {
      if(this.signup_new_pass_type)
        this.signup_new_pass_type = false;
      else
        this.signup_new_pass_type = true;
    } else if ( type == 'signup_confirm_pass_type' ) {
      if(this.signup_confirm_pass_type)
        this.signup_confirm_pass_type = false;
      else
        this.signup_confirm_pass_type = true;
    }
  }


  public setsLoginForm(){
    this.bp.validation_error = '';
    this.login_error_msg = '';
    this.signup_error_msg = '';
    this.loginForm = this.builder.group({
      email: ['', Validators.compose( [Validators.required, Validators.pattern('([a-zA-Z0-9_.]{1}[a-zA-Z0-9_.]*)((@[a-zA-Z\-]{2}[a-zA-Z\-]*)[\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))([\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))?')] )],
      password: ['', Validators.compose([Validators.required])],
    })
  }


  public setSignupForm(){
    this.bp.validation_error = '';
    this.login_error_msg = '';
    this.signup_error_msg = '';
    this.signupForm = this.builder.group({
      full_name: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.pattern('([a-zA-Z0-9_.]{1}[a-zA-Z0-9_.]*)((@[a-zA-Z\-]{2}[a-zA-Z\-]*)[\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))([\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))?')])],
      phone: [''],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(20)])],
      confirm_password:['', Validators.compose([Validators.required])],
      country_id:['', Validators.compose([Validators.required])],
      island_id:['', Validators.compose([Validators.required])],
      terms:['']
    })
  }

  toggleMenu() {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnInit() {
  }

  logout(){
    this.up.logout();
  }

  states;
  changeCountry(e: any){
    this.isDisabled = false;
    this.states = this.up.getState(e);
  }
  
  fgpOpen(content) {
    this.bp.close();
    this.bp.model_type = 'fgpass';
    this.bp.model = this.modalService.open(ForgotPassComponent, { windowClass: 'forgot-modal' });
    return false;
  }
  
  public loginFormSubmit (event) {
    
    if( event.keyCode == 13 || event.keyCode == undefined ){
      let p = window.location.pathname.replace(this.bp.SUBFOLDER_NAME, "")
      if(this.bp.validation(this.loginForm)) {
        this.bp.validation_error = '';
        this.login_error_msg='';
        let submitData = this.loginForm.value;
        submitData.device_type = this.bp.device_type;
        this.bp.hitApi('users/login', 'POST', submitData)
        .subscribe(
          success => {
            if(success.type) {
              
              this.up.login(success.data).subscribe(
                success1=>{ 
                  
                  this.setsLoginForm();
                  this.bp.close();

                  if (success.data.shipping_address == 0 || success.data.home_address == 0 ){

                    let isHome = false;
                    if (success.data.home_address == 0 ){
                      isHome = true;
                    }

                    if (success.data.shipping_address == 0 ){
                      this.add_shipping_addr(isHome,success.message);
                    } else {
                      if (isHome) {
                        this.bp.show_toast('Info','Please enter Home address.');
                        this.router.navigate(['shippingAdd']);
                      }
                    }
                    
                  } else {
                    this.bp.show_toast('Success',success.message);
                    //let redirect = this.up.redirectUrl ? this.up.redirectUrl : window.location.pathname;
                    console.log('predirectredirectredirectr===', p)
                    let redirect = this.up.redirectUrl ? this.up.redirectUrl : p;
                    //let redirect = p;
                    console.log(this.up.redirectUrl, '====redirectredirectredirectredirect>', redirect)
                    this.router.navigate([redirect]);
                  }


                },
                error=>{}
              );
            } else {
              //this.bp.validation_error = success.message;
              this.login_error_msg = success.message;
            }
          }, error => {}
        )
      } else {
        this.login_error_msg = this.bp.validation_error;
      }
    }
    
  }

  public add_shipping_addr(isHome,LoginMsg){
    
    let p = window.location.pathname.replace(this.bp.SUBFOLDER_NAME, "")
    var data = {
      address_type : 'Shipping',
      country_id: this.up.tempData.country_id,
      island_id: this.up.tempData.island_id,
      phone: '',
      address: this.up.tempData.SHIPPING_ADD1,
      city:this.up.tempData.SHIPPING_ADD2
    };
    var address = new Array();
    address.push(data);
    var newData = Object.assign({}, {address:address});

    this.bp.hitApi('users/save_address', 'POST', newData,false,true)
    .subscribe(
      success => {
        if (success.type == true) {
          this.up.setUserAddressCount('shipping_address','1');
          if (isHome) {
            this.bp.show_toast('Info','Please enter Home address.');
            this.router.navigate(['shippingAdd']);
          } else{
            this.bp.show_toast('Success',LoginMsg);
            let redirect = this.up.redirectUrl ? this.up.redirectUrl : p;
            this.router.navigate([redirect]);
          }
        } else {
          this.bp.show_toast('Error',success.message);
        }
      }, error => {

      }
    );
  }

  public signupFormSubmit (event) {

    if( event.keyCode == 13 || event.keyCode == undefined ){
      var validation_message = {
        'full_name': {
          'required': 'Full name is required field.',
          'invalidChar': 'Please provide valid full name'
        },
        'email': {
          'required': 'Email is required field.',
          'pattern': 'Please enter valid email.'
        },
        'password': {
          'required': 'Password is required field.',
          'minlength': 'Password length must be between 6 to 20.',
          'maxlength': 'Password length must be between 6 to 20.'
        }, 
        'confirm_password': {
          'required': 'Confirm password must be equal to password.'
        },
        'country_id': {
          'required': 'Please select country.'
        },
        'island_id': {
          'required': 'Please select Island/Parish.'
        },
        'terms': {
          'required': 'Please agree with Terms & Conditions.',
        }
      };
  
      //console.log(this.signupForm);
  
      let p = window.location.pathname.replace(this.bp.SUBFOLDER_NAME, "");
      if(this.bp.validation(this.signupForm, validation_message)) {
        this.bp.validation_error = ''; 
        this.signup_error_msg = '';
        if (this.signupForm.value.password != this.signupForm.value.confirm_password) {
          //this.bp.showAlert(validation_message['confirm_password']['required']);
          this.signup_error_msg = validation_message['confirm_password']['required'];
          return false;
        }
  
        if (!this.signupForm.value.terms) {
          //this.bp.showAlert(validation_message['terms']['required']);
          this.signup_error_msg = validation_message['terms']['required'];
          return false;
        }
  
        let submitData = this.signupForm.value;
        submitData.device_type = this.bp.device_type;
        this.bp.hitApi('users/sign_up', 'POST', submitData)
        .subscribe(
        success => {
          if (success.type) {
            
            this.setSignupForm();
            this.bp.close();
            //let redirect = this.up.redirectUrl ? this.up.redirectUrl : p;
            //this.router.navigate([redirect]);
  
            this.up.sid = success.data.sid;
            this.up.email = success.data.email;
            this.up.tempData = success.data;
            this.up.setData(success.data);
            this.add_shipping_addr(1,success.message);
  
            //this.bp.show_toast('Success',success.message);
            //this.router.navigate(['shippingAdd']);
          } else {
            this.signup_error_msg = success.message; 
          }
        }, error => { })
      } else {
        this.signup_error_msg = this.bp.validation_error; 
      }
    }
    

  }

  

}



// WEBPACK FOOTER //
// ./src/app/signin-up/signin-up.component.ts